/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { useContext, useEffect } from "react";
import dynamic from "next/dynamic";
import cx from "classnames";
import {
  ImageHelper,
  ThemeContext,
  channelTagsFromMedia,
  IMediaModel,
} from "@nf/common";

import { AppImage } from "../../components/AppImage/AppImage";

const MediaSEO = dynamic(() => import("components/SEO/MediaSEO"));

import styles from "./MediaDetailsScreen.module.scss";

export interface MediaDetailsScreenProps {
  media?: IMediaModel;
  className?: string;
  children?: JSX.Element;
}

export const MediaDetailsScreen = ({
  media,
  className,
  children,
}: MediaDetailsScreenProps) => {
  const channelContext = useContext(ThemeContext);
  const bannerImageUrl = ImageHelper.getHeroAssetDetailsImageUrl(media?.Images);

  useEffect(() => {
    if (media && channelContext.onBrandingChange) {
      channelContext.onBrandingChange(channelTagsFromMedia(media));
    }

    return () => {
      // Restoring default branding
      channelContext?.onBrandingChange?.();
    };
  }, [media]);

  if (!media) {
    return null;
  }

  return (
    <>
      <MediaSEO media={media} />

      <div className={cx(styles.background, className)}>
        {bannerImageUrl && (
          <AppImage
            src={bannerImageUrl}
            alt={media?.Title || ""}
            fill={true}
            isLCP
            className={styles.img}
          />
        )}

        <div className={styles.gradientTop} />

        <div className={styles.gradient} />
      </div>

      <div className={styles.container}>{children}</div>
    </>
  );
};

export default MediaDetailsScreen;
